import V3Check from './V3Check'
import { CheckUtils } from 'utils'
import { HelpEmail } from 'components'

export default class V3BodyTextCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>Body text is all of the visible text on your page that isn't in a heading H1 or any of the H2, H3 etc. subheadings</p>
        <hr />

        <h2>How it's used</h2>
        <ul>
          <li>Used in search engine algorithms for ranking</li>
        </ul>
        <hr />

        <h2>Best practice</h2>
        <ul>
          <li>Every page should have at least a couple of paragraphs of body text</li>
          <li>A page with just images and no body text will struggle to be featured in search engines</li>
          <li>Include a few of your keywords in natural sentences, paragraphs and lists like this one</li>
        </ul>
        <hr />

        <h2>How to fix</h2>
        <h3>Homepage</h3>
        <p>This varies depending on the theme you're using. Usually there's a theme setting where you can select the page that your homepage content comes from. Find that page in your Shopify admin, then include keywords in its 'Content'.</p>
        <p>Alternatively you can edit the index.liquid template in the Shopify admin theme editor to add body text to your homepage.</p>

        <h3>Products and Collections</h3>
        <p>Edit the product or collection in your Shopify admin, adding keywords to its 'Description'.</p>

        <h3>Pages and Blog posts</h3>
        <p>Edit the page or blog post in your Shopify admin, adding keywords to its 'Content'.</p>

        <h3>Blog</h3>
        <p>The blog page usually lists your latest blog posts with a few lines from each one. So the simplest way to add body text keywords is to make sure you mention the keywords in the first few lines of each blog post.</p>
        <p>Alternatively you can edit the blog.liquid template in the Shopify admin theme editor.</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3BodyTextCheck.js